import React, { useEffect, useRef, useState } from "react";
import './index.css';
import { Col, Row } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { scrollbarData } from '../../../dummyData/scrollBarData';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightDots } from "@fortawesome/free-solid-svg-icons";
import img5 from "../../../assets/images/IM0204.PNG";

const Dashboard03 = () => {
  const imageRef = useRef<HTMLImageElement>(null);
  const scrollbarRef = useRef(null);
  const [scrollbarHeight, setScrollbarHeight] = useState<number>(800);

  useEffect(() => {
      const updateHeight = () => {
        if (imageRef.current) {
          const imgHeight = imageRef.current.offsetHeight;
          setScrollbarHeight(imgHeight);
        }
      };
  
      const imageElement = imageRef.current;
      if (imageElement && imageElement.complete) {
        updateHeight();
      } else if (imageElement) {
        imageElement.addEventListener("load", updateHeight);
      }
  
      window.addEventListener("resize", updateHeight);
  
      return () => {
        window.removeEventListener("resize", updateHeight);
        if (imageElement) {
          imageElement.removeEventListener("load", updateHeight);
        }
      };
    }, []);  

  return (
    <>
      <Row className="p-4 mt-5 dashboard-columns d-flex justify-content-center align-items-center">
        <Col xs={12} lg={6} className="my-4 mb-lg-0">
          <img
            ref={imageRef}
            src={img5}
            alt="Dashboard03"
            className="dashbaord-03-img w-100"
          />
        </Col>
        <Col xs={12} lg={6}>
          <PerfectScrollbar
            ref={scrollbarRef}
            className="scrollbar-container"
            style={{ height: `${scrollbarHeight}px`, paddingLeft: "70px" }}
          >
            <h1 className="px-5 dashboard03-content-header mb-5">
              Order in Just a Few Clicks
            </h1>
            {scrollbarData.map((item, index) => (
              <div key={index} className="scrollbar-content">
                <div className="d-flex align-items-start gap-3">
                  <img src={item.icon} alt="icon" className="icon-img" />
                  <div className="d-flex flex-column">
                    <h1 className="scrollbar-title mb-4">{item.title}</h1>
                    <p className="scrollbar-text">{item.content}</p>
                    <Link to="/order" className="mb-4 text-black">
                      Order Now{" "}
                      <FontAwesomeIcon
                        icon={faArrowUpRightDots}
                        className="px-1"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </PerfectScrollbar>
        </Col>
      </Row>
    </>
  );
}

export default Dashboard03;